import ListTag1 from './ListTag1'
import {ListTagTeam2 , ListTagLogoSpotify} from '../../utils/allImgs'
/**
 * ListTag - Demo/example list showing two sample notification items
 *
 * Renders two hardcoded ListTag1 items as a demonstration of the dropdown
 * notification style. Uses sample data for a message notification and an album release.
 *
 * @returns {React.ReactElement} Rendered list of sample notification items
 */
function ListTag(){
    return null;
  /*return(
    <>
      <ListTag1
              path='/'
              img={ListTagTeam2}
              classOfName="avatar avatar-sm  me-3 "
              text1='New message'
              text2='from Laur'
              text3='13 minutes ago'
      />

      <ListTag1
              path='/'
              img={ListTagLogoSpotify}
              classOfName="avatar avatar-sm bg-gradient-dark  me-3 "
              text1='New album'
              text2='by Travis Scott'
              text3='1 day'
      />
    </>
    )*/

}

export default ListTag